<div class="cpcontent">
    <h2>Roles</h2>


    <br><br>
    <div class="row">
        <div class="col-md-6">
            <button class="btn btn-primary" (click)="add()">New Role</button>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let r of roles">
                        <td>{{r.id}}</td>
                        <td class="link" (click)="selectRole(r)">{{r.name}}</td>
                        <td><button class="btn btn-warning btn-small" (click)="delete(r)">Delete</button></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-6">
            <span class="inline"> Id: {{role.id}}</span>
            <sa-input-text class="inline" [(text)]="role.name" [title]="'Name'" [required]="'none'"></sa-input-text>
            <button class="btn btn-primary inline" (click)="submit()">Submit</button>
            <br>
        </div>
    </div>

</div>